import classNames from 'classnames';
import { observer } from 'mobx-react';

import { useStores } from '../../stores/useStores';

import './style.scss';

export const NotificationDot = observer((props: { type?: 'small' | 'normal' }) => {
  const { rewardsStore } = useStores();
  if (!rewardsStore.inviteBonusNotification) return null;

  return (
    <div className={classNames('notification-dot', props.type)}>
      <div className="dot"></div>
    </div>
  );
});
